module.exports = __webpack_public_path__ + "img/os_iocn_ser@2x.abf21cb6.png";